import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { SERVICES_LIST, PAGE_BANNERS } from "../data/content";

export default function ServicesList() {
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.services} alt="Services" fallbackKey="services" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h2 className="!text-2xl !mt-0">
            Nourish Natural Health Clinic offers the following Services:
          </h2>
          <ul>
            {SERVICES_LIST.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </article>
      </div>
    </div>
  );
}
